export function GlobalFooterLogo() {
  return (
    <div className="pointer-events-none fixed bottom-8 inset-x-0 flex justify-center z-10 opacity-80">
      <img
        src="/assets/bdd-logo-text.png"
        alt="A Universe Named BDD"
        className="h-6"
      />
    </div>
  );
}
